import { Components, Theme } from "@mui/material";
export const muiCheckboxTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiCheckbox"> => ({
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: theme.palette.text.disabled,
        alignItems: "start",
      },
    },
    variants: [
      {
        props: {
          size: "small",
        },
        style: {
          padding: "6px",
        },
      },
    ],
  },
});
